import { useNavigate } from 'react-router-dom';
import { Button } from './Button';
import './ComingSoon.css';

export function ComingSoon() {
   const navigate = useNavigate();
   return (
      <div className="flex flex-col items-center justify-center gap-4">
         <div className="flex flex-col items-center gap-1 opacity-50">
            <img
               src="/assets/icons/lock-icon-lighter.svg"
               alt=""
               width={50}
            />
            <h4 className="gray">Feature will be available soon</h4>
         </div>
         <Button
            title="Back to Homepage"
            type="white-big"
            onClick={() => navigate('/')}
         />
      </div>
   );
}
